import { all } from 'redux-saga/effects';

import { getCategoriesSagaWatcher } from './get_categories.saga'
import { addCategorySagaWatcher } from './add_category.saga'
import { updateCategorySagaWatcher } from './update_category.saga'
import { deleteCategorySagaWatcher } from './delete_category.saga'
import { reOrderCategoriesSagaWatcher } from './reorder_categories.saga'

export default function* categorySaga() {
    yield all([
        getCategoriesSagaWatcher(),
        addCategorySagaWatcher(),
        updateCategorySagaWatcher(),
        deleteCategorySagaWatcher(),
        reOrderCategoriesSagaWatcher()
    ]);
}